var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReferralShapes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M35.25 21H33H21C12.72 21 6 27.72 6 36V51C6 59.28 12.72 66 21 66H36C44.28 66 51 59.28 51 51V39V36.75C51 28.05 43.95 21 35.25 21Z",
    fill: "#C7D7F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5 6C40.89 6 33.84 12.6 33.09 21H35.25C43.95 21 51 28.05 51 36.75V38.91C59.4 38.16 66 31.08 66 22.5C66 13.38 58.62 6 49.5 6Z",
    fill: "#437ADB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferralShapes);
export default __webpack_public_path__ + "static/media/referral-shapes.3133b5bd941ceaf765b2a3e073e83f1f.svg";
export { ForwardRef as ReactComponent };